import { chatThread, recordCards } from '@/mocks/siteContent';
import { SectionHead } from './kit';

export default function Records() {
  return (
    <section id="records" className="mx-auto max-w-6xl px-4 py-14 md:px-6 md:py-20">
      <SectionHead
        index="贰"
        kicker="聊天记录流出"
        title="一张截图是怎么传开的"
        desc="我们不只判断真假，也还原传播路径——原始流出片段如何从 8 人群一步步扩散成全网热议，以及为什么截图不能直接当作证据。"
      />

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
        {/* large chat card */}
        <div className="lg:col-span-8">
          <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
            <div className="flex items-center justify-between border-b border-background-200 px-5 py-4">
              <div className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-200 text-secondary-800">
                  <i className="ri-team-line" aria-hidden="true" />
                </span>
                <div>
                  <h3 className="font-heading text-sm font-bold text-foreground-950">
                    {chatThread.groupName}
                  </h3>
                  <p className="text-[11px] text-foreground-500">原始流出片段 · 已做匿名化处理</p>
                </div>
              </div>
              <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-100 px-2.5 py-1 text-[11px] font-medium text-accent-900">
                <span className="h-1.5 w-1.5 rounded-full bg-accent-500" />
                待核验片段
              </span>
            </div>
            <div className="space-y-4 bg-background-100/50 px-5 py-6">
              {chatThread.lines.map((m) => (
                <div
                  key={m.time}
                  className={`flex ${m.role === 'self' ? 'justify-end' : 'justify-start'}`}
                >
                  {m.role === 'other' ? (
                    <span className="mr-2 mt-2 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-secondary-200 text-xs text-secondary-800">
                      {m.name.slice(0, 1)}
                    </span>
                  ) : null}
                  <div
                    className={`max-w-[75%] rounded-lg px-4 py-3 ${
                      m.role === 'self'
                        ? 'rounded-tr-none bg-primary-500 text-background-50'
                        : 'rounded-tl-none border border-background-200 bg-background-50'
                    }`}
                  >
                    <p className="text-xs text-foreground-500 md:hidden">{m.name}</p>
                    <p
                      className={`text-sm leading-relaxed ${
                        m.role === 'self' ? 'text-background-50' : 'text-foreground-800'
                      }`}
                    >
                      {m.text}
                    </p>
                    <p
                      className={`mt-1 text-right text-[11px] ${
                        m.role === 'self' ? 'text-background-100' : 'text-foreground-500'
                      }`}
                    >
                      {m.time}
                    </p>
                  </div>
                </div>
              ))}
            </div>
            <div className="border-t border-background-200 bg-accent-50/60 px-5 py-3 text-[11px] text-accent-900">
              栏目点评：截图缺少原始发布者署名，字迹与台标存在改图痕迹，按「无原始出处」规则暂不采信。
            </div>
          </div>
        </div>

        {/* small stacked cards */}
        <div className="flex flex-col gap-6 lg:col-span-4">
          {recordCards.map((c) => (
            <article
              key={c.no}
              className="flex flex-1 flex-col rounded-lg border border-background-200 bg-background-50 p-6"
            >
              <div className="mb-5 flex items-center justify-between">
                <span className="inline-flex items-center gap-2 text-[11px] font-semibold tracking-wide text-primary-600">
                  <span className="flex h-6 w-6 items-center justify-center rounded bg-primary-100 text-primary-700">
                    {c.no}
                  </span>
                  截图流出 · {c.tag}
                </span>
                <i className="ri-file-copy-line text-background-300" aria-hidden="true" />
              </div>
              <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950">
                {c.title}
              </h3>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">{c.body}</p>
              <span className="mt-5 inline-flex items-center gap-1 text-xs font-medium text-primary-600">
                <i className="ri-links-fill" aria-hidden="true" />
                已在台账留档核对
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}